var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',{staticClass:"text-center"},[_c('v-col',{attrs:{"cols":"12"}},[_c('v-img',{staticClass:"my-3",attrs:{"src":"/img/citamixinternet.jpg","contain":""}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }